import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { useMutation } from '@tanstack/react-query'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
import useDialog from 'hooks/Shared/useDialog'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { MutationOptions } from 'models/general'
import { PaymentComplement } from 'models/invoices.models'
import { cancelPaymentComplement } from 'services/Invoices/invoices.services'

const useCancelPaymentComplement = (
    workspaceId: number,
    options: MutationOptions<
        void,
        { payComplement: PaymentComplement; reason: number; substitute?: string }
    > = {}
) => {
  const dialog = useDialog()
  const { onBefore, onError, noDialog, ...rest } = options

  const mutation = useMutation<
      void,
      any,
      { payComplement: PaymentComplement; reason: number; substitute?: string }
  >(
      ({ payComplement, reason, substitute }) => {
        onBefore && onBefore({ payComplement, reason, substitute })
        return cancelPaymentComplement(workspaceId, payComplement, reason, substitute)
      },
      {
        ...rest,
        onError: async (error, variables, ctx) => {
          const op = selectErrorDialog(error)
          if (op?.variant) {
            await dialog[op.variant](op)
            return
          }
          if (!noDialog) {
            const rp = await dialog.dangerAsync({
              title: 'generic.error.title',
              subtitle: 'No se pudo cancelar el complemento de pago seleccionado.',
              icon: ErrorOutline as TModalIcon,
              primaryButtonText: 'Reintentar',
              secondaryButtonText: 'Cancelar',
            })

            if (rp) {
              mutation.mutate(variables)
              return
            }
          }

          onError && onError(error, variables, ctx)
        },
      }
  )

  return mutation
}

export default useCancelPaymentComplement
